'use strict';

var _Customer = require('./components/Customer');

var _Customer2 = _interopRequireDefault(_Customer);

var _Customers = require('./components/Customers');

var _Customers2 = _interopRequireDefault(_Customers);

var _Baja = require('./components/Baja');

var _Baja2 = _interopRequireDefault(_Baja);

var _BajaAction = require('./components/Baja-action');

var _BajaAction2 = _interopRequireDefault(_BajaAction);

var _BajaDetalle = require('./components/Baja-detalle');

var _BajaDetalle2 = _interopRequireDefault(_BajaDetalle);

var _Cambios = require('./components/Cambios');

var _Cambios2 = _interopRequireDefault(_Cambios);

var _CambiosDetalle = require('./components/Cambios-detalle');

var _CambiosDetalle2 = _interopRequireDefault(_CambiosDetalle);

var _Status = require('./components/Status');

var _Status2 = _interopRequireDefault(_Status);

var _CustomerLiderCedis = require('./components/CustomerLiderCedis');

var _CustomerLiderCedis2 = _interopRequireDefault(_CustomerLiderCedis);

var _LastOrdersMenuMonitoring = require('./components/LastOrdersMenuMonitoring');

var _LastOrdersMenuMonitoring2 = _interopRequireDefault(_LastOrdersMenuMonitoring);

var _NewUsersMenuMonitoring = require('./components/NewUsersMenuMonitoring');

var _NewUsersMenuMonitoring2 = _interopRequireDefault(_NewUsersMenuMonitoring);

var _SearchMonitoring = require('./components/SearchMonitoring');

var _SearchMonitoring2 = _interopRequireDefault(_SearchMonitoring);

var _CustomerUpdateLider = require('./components/CustomerUpdateLider');

var _CustomerUpdateLider2 = _interopRequireDefault(_CustomerUpdateLider);

var _UpdateDetalle = require('./components/UpdateDetalle');

var _UpdateDetalle2 = _interopRequireDefault(_UpdateDetalle);

var _StatusActualizacion = require('./components/StatusActualizacion');

var _StatusActualizacion2 = _interopRequireDefault(_StatusActualizacion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customer = new _Customer2.default();

var customers = new _Customers2.default();

var baja = new _Baja2.default();

var bajaAction = new _BajaAction2.default();

var bajaDetalle = new _BajaDetalle2.default();

var cambios = new _Cambios2.default();

var cambiosDetalle = new _CambiosDetalle2.default();

var status = new _Status2.default();

var customerLiderCedis = new _CustomerLiderCedis2.default();

var lastOrdersMenuMonitoring = new _LastOrdersMenuMonitoring2.default();

var newUsersMenuMonitoring = new _NewUsersMenuMonitoring2.default();

var searchMonitoring = new _SearchMonitoring2.default();

var customerUpdateLider = new _CustomerUpdateLider2.default();

var updateDetalle = new _UpdateDetalle2.default();

var statusActualizacion = new _StatusActualizacion2.default();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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